import { render, staticRenderFns } from "./NextcloudUserStatus.vue?vue&type=template&id=3edd61d2&scoped=true&"
import script from "./NextcloudUserStatus.vue?vue&type=script&lang=js&"
export * from "./NextcloudUserStatus.vue?vue&type=script&lang=js&"
import style0 from "./NextcloudUserStatus.vue?vue&type=style&index=0&id=3edd61d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edd61d2",
  null
  
)

export default component.exports